export const userTypes = {
  admin: 'Admin',
  fieldTechnician: 'Field Technician',
  accounting: 'Accounting',
  fleetMaintenance: 'Fleet Maintenance',
  projectManagement: 'Project Management',
  dispatcher: 'Dispatcher',
  machineShop: 'Machine Shop',
};
